import { render, staticRenderFns } from "./PatientSettingList.vue?vue&type=template&id=53ee63c3&scoped=true&"
import script from "./PatientSettingList.vue?vue&type=script&lang=js&"
export * from "./PatientSettingList.vue?vue&type=script&lang=js&"
import style0 from "./PatientSettingList.vue?vue&type=style&index=0&id=53ee63c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ee63c3",
  null
  
)

export default component.exports